module.exports = __webpack_public_path__ + "img/tabbar_icon_file_24_pressed.998727ff.svg";